"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOOGLE_OAUTH_CLIENT_ID = void 0;
// REPLACE: replace with project's client ID
// ID copied from https://console.cloud.google.com/apis/credentials?project=side-project-stack-6ec08
exports.GOOGLE_OAUTH_CLIENT_ID = "1080046077031-9ptmrneknefi8bk0oc0pe93tnl5p6aka.apps.googleusercontent.com";
